import * as React from 'react';

interface DrawdownBoxProps {
  heading: string;
  type: string;
  income: string;
  percent: string;
  timeframe: string;
  age: string;
}

const DrawdownBox = ({
  heading,
  type,
  income,
  percent,
  timeframe,
  age,
}: DrawdownBoxProps) => (
  <div className="drawdown-box">
    <div className="section">
      <div className="header">
        <h4>{heading}</h4>
      </div>
      <div className="body">
        <p className="subheading">{type}</p>
        <div className="income-values">
          <div className="income">
            <div className="highlight">{income}</div>
            <div>annually</div>
          </div>
          <div className="percent">
            <div className="highlight">{percent}</div>
            <div>of your current total pot value</div>
          </div>
        </div>
        <hr />
        <div>
          <p className="subheading">Your pension pot is estimated to last:</p>
          <div className="highlight padded">{timeframe}</div>
          <p className="padded">{age}</p>
        </div>
      </div>
    </div>
  </div>
);

export default DrawdownBox;



// WEBPACK FOOTER //
// ./src/components/Outputs/DrawdownBox/DrawdownBox.tsx